<template>
  <div>
    <!-- 仓库 -->
    <el-dialog :title="$t('message.warehouse')" :close-on-click-modal="false" append-to-body
      :visible.sync="$parent.warehouseDialogVisible" width="1820px" center>
      <div class="content">
        <!-- 上架或移库选库时显示本次勾选商品所属的订单信息。 -->
        <div class="up-storage-order-list" v-if="[1, 14].includes(type) && order_info.length">
          <div class="up-storage-order-info" v-for="item in order_info" :key="item.order_sn">
            <div class="order-time">
              <p>{{ $t("message.customerPaymentTime") }}</p>
              <p>{{ item.datetime_pay_confirm }}</p>
            </div>
            <div class="order-customer">
              <div>
                <b v-if="item.user && item.user.authorized == 1">[授权]</b>
                <router-link :to="'orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">
                  {{ item.order_sn }}
                </router-link>
                <span class="attribute-name">
                  <attributeName :name="item.order_attribute" />
                </span>
                <i class="el-icon-copy-document" @click="copy(item.order_sn)"></i>
              </div>
              <div class="customer-name">
                {{ item.user ? item.user.realname : '' }}
                <span class="attribute-name">
                  <attributeName :name="item.user_attribute" />
                </span>
              </div>
            </div>
            <div class="order-number">
              <p>
                {{ $t("message.transactionNumber") }}：
                <span class="a-link">{{ item.purchase_no }}</span>
                <i class="el-icon-copy-document" @click="copy(item.purchase_no)"></i>
              </p>
              <p>
                {{ $t("message.logisticsNumber") }}：
                <span class="a-link">{{ getFirstExpressNo(item) }}</span>
                <i class="el-icon-copy-document" v-if="getFirstExpressNo(item) != '-'"
                  @click="copy(getFirstExpressNo(item))"></i>
                <el-tooltip placement="top" v-if="getOrderExpressList(item).length > 1">
                  <div slot="content">
                    <p v-for="(express, index) in getOrderExpressList(item)" :key="index">
                      {{ $t("message.logisticsNumber") }}{{ index + 1 }}：{{ express.express_no }}
                    </p>
                  </div>
                  <el-button size="mini" type="primary" icon="el-icon-search" class="express-list-button"></el-button>
                </el-tooltip>
              </p>
            </div>
            <div class="order-staff">
              <span>{{ $t("message.business") }}：{{ item.y_name }}</span>
              <span>{{ $t("message.purchase") }}：{{ item.g_name }}</span>
              <span>{{ $t("message.distribution") }}：{{ item.p_name }}</span>
            </div>
            <div class="order-shelf-filter">
              <span>筛选使用范围{{ getCurrentAdminName() }}的货架</span>
              <el-switch v-model="filterOrderShelf" @change="changeOrderShelfFilter"></el-switch>
            </div>
          </div>

        </div>
        <!-- 菜单 -->
        <div class="nav">
          <!--  公共区域 -->
          <div class="item" :class="{ index: i == 2 }" @click="getIndex('2')">
            {{ $t("message.commonArea") }}
          </div>
          <!--个人区域  -->
          <div class="item" :class="{ index: i == 1 }" @click="getIndex('1')">
            {{ $t("message.personalArea") }}
          </div>
          <div class="item shelf-filter" :class="{ index: shelfRemarkFilter == '大货' }"
            @click="setShelfRemarkFilter('大货')">
            大货
          </div>
          <div class="item shelf-filter" :class="{ index: shelfRemarkFilter == 'FBA' }"
            @click="setShelfRemarkFilter('FBA')">
            FBA
          </div>
          <div class="warehouse-legend">
            <span class="legend-item">
              <i class="legend-dot empty"></i>
              白色：空库位
            </span>
            <span class="legend-item">
              <i class="legend-dot has-stock"></i>
              绿色：有货的库位
            </span>
            <span class="legend-item">
              <i class="legend-dot customer-stock"></i>
              黑色：此次上架商品对应客户的商品库位
            </span>
            <span class="legend-item">
              <i class="legend-dot same-goods"></i>
              黄色：此次上架商品同番商品库位
            </span>
          </div>
          <!-- 货架布局编辑操作，与仓库功能测试页保持一致。 -->
          <div class="layout-actions">
            <el-button class="layout-button" size="small" type="primary" @click="toggleLayoutEditing">
              {{ layoutEditing ? '保存布局' : '编辑布局' }}
            </el-button>
            <el-button class="layout-button" size="small" @click="resetShelfLayout">
              恢复默认布局
            </el-button>
          </div>
        </div>
        <!-- 货架列表 -->
        <div class="list" :class="{ 'with-order-info': [1, 14].includes(type) && order_info.length }">
          <div ref="shelfCanvas" class="shelf-canvas"
            :class="{ 'free-layout': freeLayoutActive, 'default-layout': !freeLayoutActive }"
            :style="freeLayoutActive ? { height: shelfCanvasHeight + 'px' } : {}">
          <!-- 单个货架；编辑模式下使用已保存的自由坐标和宽度。 -->
          <div class="shelves warehouse-feature-shelf" :class="{ 'layout-editing': layoutEditing }"
            v-for="shelves in list" :key="getShelfKey(shelves)" :data-shelf-key="getShelfKey(shelves)"
            :style="shelfPositionStyle(shelves)">
              <!-- 货架主体 -->
              <div class="shelves-main">
                <div class="header">
                  <!-- 直接展示完整货架编号，使用范围继续展示人员或部门。 -->
                  <div class="serialNumber">
                    <p>{{ shelves.shelf_number }}</p>
                  </div>
                  <div class="key-range">{{ $t("message.scopeOfUse") }}</div>
                  <div class="range">{{ getShelfRangeName(shelves) }}</div>
                </div>
              <!-- 每层 -->
              <div class="row" v-for="(item, index) in shelves.wms_grid" :key="index">
                <div class="key">{{ item.floor }}层</div>

                <!-- 每一层 -->
                <div class="each-layer">
                  <div v-for="(items, indexs) in item.grids" :key="indexs">
                    <el-tooltip class="item" effect="dark" :content="items.grid_number" placement="top">
                      <div class="item" :class="gridStatusClass(items)" @click="chooseOperation(items, shelves, item)">
                        {{ items.no }}
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <!-- 货架名称 -->
            <div class="shelves-name drag-handle">
              <i v-if="layoutEditing" class="el-icon-rank drag-icon"></i>
              {{ shelves. area_type_code }}
            </div>

          </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 库位商品 -->
    <el-dialog :title="$t('message.warehouseGoods')" :close-on-click-modal="false" append-to-body
      :visible.sync="warehouseGoodsDialogVisible" width="920px" center @close="resetGoods">
      <div class="content">
        <div class="table">
          <ol>
            <!--订单号  -->
            <li>{{ $t("message.orderNumber") }}</li>
            <!--番号  -->
            <li class="flex05">{{ $t("message.mash") }}</li>
            <!--图片  -->
            <li class="flex05">{{ $t("message.pic") }}</li>
            <!--库存数  -->
            <li class="flex05">{{ $t("message.numberOfInventory") }}</li>
            <!--交易号  -->
            <li>{{ $t("message.transactionNumber") }}</li>
            <!--物流号  -->
            <li>{{ $t("message.logisticsNumber") }}</li>
          </ol>
          <div class="wu" v-if="goodList == false">暂无数据</div>
          <ul v-for="(item, index) in goodList" :key="index">
            <!--订单号  -->
            <li>{{ item.order_purchase.order_sn }}</li>
            <!--番号  -->
            <li class="flex05">
              {{ item.order_purchase.order_detail.sorting }}
            </li>
            <!--图片  -->
            <li class="flex05">
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.order_purchase.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                <a :href="`https://detail.1688.com/offer/${item.order_purchase.order_detail.goods_id}.html`"
                  target="_blank" slot="reference">
                  <img :src="item.order_purchase.order_detail.pic" style="width: 60px" alt="" />
                </a>
              </el-popover>
            </li>
            <!--库存数  -->
            <li class="flex05">{{ item.num }}</li>
            <!--交易号  -->
            <li>{{ item.order_purchase.purchase_no }}</li>
            <!--物流号  -->
            <li>
              <div class="template">
                <p v-for="(express, expressIndex) in item.order_purchase
                  .order_purchase_express" :key="expressIndex">
                  WL{{ expressIndex + 1 }}:{{ express.express_no }}
                </p>
              </div>
            </li>
          </ul>
          <div class="wu" v-if="total > goodList.length"> <el-button size="mini" type="primary"
              @click="gridStockDetail">查看更多</el-button></div>
        </div>
      </div>
    </el-dialog>
    <!-- 库位选择操作 -->
    <el-dialog title="操作选择" :close-on-click-modal="false" append-to-body :visible.sync="operationDialogVisible"
      width="420px" center>
      <div class="btn">
        <el-button type="primary" class="primary" @click="gridStockDetail" v-if="type != 7">查看库位商品</el-button>
        <el-button type="primary" @click="followUpStorage" v-if="type == 1">入库</el-button>
        <el-button type="primary" @click="boxToNormalWms" v-else-if="type == 2">入库</el-button>
        <el-button type="primary" @click="boxToChargeWms" v-else-if="type == 3">入库</el-button>
        <el-button type="primary" v-else-if="type == 4" @click="outBoxSubmit">取出</el-button>
        <!-- 批量取出 -->
        <el-button type="primary" v-else-if="type == 5" @click="outBoxBatchSubmit">放入库位</el-button>
        <!-- 多商品全部取出 -->
        <el-button type="primary" v-else-if="type == 6" @click="outBoxAllSubmit">放入库位</el-button>
        <!-- 存入长存仓库 -->
        <el-button type="primary" v-else-if="type == 7" @click="batchUpToShelf">直接上架</el-button>
        <!-- 转库单取消装箱 -->
        <el-button type="primary" v-else-if="type == 8" @click="moveOutBox">取消装箱</el-button>
        <!-- 转库单取消装箱 -->
        <el-button type="primary" v-else-if="type == 9" @click="batchMoveBackToNormal">放入库位</el-button>
        <!-- 打印上架唛头 -->
        <el-button type="primary" v-else-if="type == 10" @click="printLabel">打印上架唛头</el-button>
        <!-- 直接装箱-选择库位后标记装箱完成 -->
        <el-button type="primary" v-else-if="type == 11" @click="boxToComplete">装箱完成</el-button>
        <!-- 普通仓库库位选择：仅回填库位号给父组件 -->
        <el-button type="primary" v-else-if="type == 12" @click="selectGridNumber">选择库位</el-button>
        <!-- 长存仓库库位选择：回填库位号给父组件 -->
        <el-button type="primary" v-else-if="type == 13" @click="selectChargeGridNumber">选择库位</el-button>
        <!-- 核查批量移库：选择目标库位后由父页面调用移库接口。 -->
        <el-button type="primary" v-else-if="type == 14" @click="selectBatchMoveGrid">确认移库</el-button>
        <!--  -->
        <el-button type="primary" @click="stockMove" v-else>入库</el-button>

      </div>
    </el-dialog>
  </div>
</template>
<script>
import shelfLayoutMixin from '@/views/home/warehouse/warehouseFeatureTest/shelfLayoutMixin'

export default {
  mixins: [shelfLayoutMixin],
  props: {
    yiku_data: { type: Array }, //移库
    up_data: { type: Array }, //上架
    boxIds: { type: Array }, //直接装箱入库
    cancelEncasementData: { type: Object }, //取出箱子商品数据
    type: { type: Number }, // 1核查-上架提交// 2 普通仓库 3 收费仓库 4 取出箱子商品 5 批量取出 6 多商品全部取出 7 存入长存仓库 8 转库单取消装箱 10 打印上架唛头 14 核查批量移库
    shelf_type_set: { type: Array }, // 查看仓库类型
    userid: { type: String }, // 客户id 显示高亮
    order_purchase_ids: { type: Array }, // 同商品高亮
    order_info: { type: Array, default: () => [] }, // 本次上架订单信息
  },
  data() {
    return {
      i: [12, 13].includes(this.type) ? 1 : (localStorage.getItem('warehouseIndex') ? localStorage.getItem('warehouseIndex') : 2),
      list: [],
      warehouseGoodsDialogVisible: false, //查看商品详情
      operationDialogVisible: false, //操作弹框
      goodList: [], //订单列表
      total: 0,//订单列表总数
      page: 1,
      item: {},
      shelves: {}, /* 当前选中的货架数据 */
      shelfLayer: {}, /* 当前选中的货架层数据 */
      warehouseData: {}, // 全部货架
      shelfRemarkFilter: '', /* 货架备注筛选条件 */
      filterOrderShelf: [1, 14].includes(this.type) && localStorage.getItem('warehouseOrderShelfFilter') == '1',
    };
  },
  created() {

    let datas = {
      shelf_type_set: this.shelf_type_set,
      user_id: this.userid ? this.userid : '',
      order_purchase_id: this.order_purchase_ids ? this.order_purchase_ids : ''
    };

    this.$api.warehouseApi.wmsGridPreview(datas).then((res) => {
      this.warehouseData = res.data;
      Object.keys(this.warehouseData).forEach((area) => {
        this.initializeShelfLayouts(area)
      })
      this.getIndex(this.i);
    });
  },
  methods: {
    // 获取订单的有效物流信息列表，用于上架订单信息展示
    getOrderExpressList(order) {
      return Array.isArray(order.order_purchase_express) ? order.order_purchase_express : [];
    },
    // 获取订单首个物流号，无物流信息时统一显示占位符
    getFirstExpressNo(order) {
      const list = this.getOrderExpressList(order);
      return list.length ? list[0].express_no : '-';
    },
    // 获取货架使用范围名称：个人货架取管理员真名，公共货架取组织名称
    getShelfRangeName(shelves) {
      return shelves.admin != null ? shelves.admin.realname : shelves.organization.name;
    },
    // 从浏览器登录信息中读取当前账号真名，作为个人货架筛选条件
    getCurrentAdminName() {
      const adminInfo = localStorage.getItem('japanUserRoleInfo');
      if (!adminInfo) return '';
      try {
        return JSON.parse(adminInfo).realname || '';
      } catch (e) {
        return '';
      }
    },
    // 保存上架及移库货架筛选开关，并立即按当前账号重新筛选货架。
    changeOrderShelfFilter(value) {
      if (![1, 14].includes(this.type)) return;
      localStorage.setItem('warehouseOrderShelfFilter', value ? '1' : '0');
      this.applyShelfRemarkFilter();
    },
    getIndex(i) {
      this.destroyShelfDragging()
      this.i = i;
      this.layoutEditing = false
      this.freeLayoutActive = !!this.customLayoutAreas[String(i)]
      if (![12, 13].includes(this.type)) {
        localStorage.setItem('warehouseIndex', i)
      }
      this.updateShelfCanvasHeight(i)
      this.applyShelfRemarkFilter();
    },
    /* 设置货架备注筛选条件，再次点击同一条件时取消筛选 */
    setShelfRemarkFilter(filter) {
      this.shelfRemarkFilter = this.shelfRemarkFilter == filter ? '' : filter;
      this.applyShelfRemarkFilter();
    },
    /* 根据当前区域、货架备注和上架账号筛选条件，过滤当前页面显示的货架数据 */
    applyShelfRemarkFilter() {
      let currentList = this.warehouseData[this.i] || [];
      if (this.shelfRemarkFilter) {
        currentList = currentList.filter((shelves) => {
          return (shelves.remark || '').indexOf(this.shelfRemarkFilter) != -1;
        });
      }
      if ([1, 14].includes(this.type) && this.filterOrderShelf) {
        const currentAdminName = this.getCurrentAdminName();
        if (currentAdminName) {
          currentList = currentList.filter(shelves => this.getShelfRangeName(shelves) == currentAdminName);
        }
      }
      this.list = currentList;
      this.$nextTick(this.setupShelfDragging)
    },
    // 库位颜色优先级：同番商品 > 当前客户商品 > 有货 > 空库位
    gridStatusClass(grid) {
      if (this.hasSameGoodsStock(grid)) return 'grid-same-goods';
      if (this.hasCustomerStock(grid)) return 'grid-customer-stock';
      if (this.hasGridStock(grid)) return 'grid-has-stock';
      return '';
    },
    hasSameGoodsStock(grid) {
      return this.hasTruthyField(grid, [
        'hasSameGoods',
        'has_same_goods',
        'hasSameGoodsStock',
        'has_same_goods_stock',
        'sameGoods',
        'same_goods',
        'sameGoodsStock',
        'same_goods_stock',
        'hasSameSorting',
        'has_same_sorting',
        'sameSorting',
        'same_sorting',
        'sameSortingStock',
        'same_sorting_stock',
        'isSameGoods',
        'is_same_goods',
        'sameOrderPurchase',
        'same_order_purchase',
        'sameOrderPurchaseStock',
        'same_order_purchase_stock'
      ]) || this.hasTruthyMatchingField(grid, (field) => {
        return field.indexOf('same') != -1
          && (field.indexOf('goods') != -1 || field.indexOf('sorting') != -1 || field.indexOf('stock') != -1 || field.indexOf('purchase') != -1);
      });
    },
    hasCustomerStock(grid) {
      return this.hasTruthyField(grid, [
        'hasCustomerStock',
        'has_customer_stock',
        'customerStock',
        'customer_stock',
        'customerGoods',
        'customer_goods',
        'customerWmsStock',
        'customer_wms_stock',
        'currentCustomerStock',
        'current_customer_stock',
        'currentCustomerGoods',
        'current_customer_goods',
        'hasCustomerGoods',
        'has_customer_goods',
        'hasUserStock',
        'has_user_stock',
        'userStock',
        'user_stock',
        'userWmsStock',
        'user_wms_stock',
        'currentUserStock',
        'current_user_stock',
        'clientStock',
        'client_stock',
        'clientGoods',
        'client_goods'
      ]) || this.hasTruthyMatchingField(grid, (field) => {
        const isCustomerField = field.indexOf('customer') != -1
          || field.indexOf('client') != -1
          || field.indexOf('user') != -1;
        return isCustomerField && (field.indexOf('stock') != -1 || field.indexOf('goods') != -1 || field.indexOf('wms') != -1);
      });
    },
    hasGridStock(grid) {
      return this.hasTruthyField(grid, [
        'hasStock',
        'has_stock',
        'hasWmsStock',
        'has_wms_stock',
        'stock',
        'stock_num',
        'stockNum',
        'totalStock',
        'total_stock',
        'wmsStock',
        'wms_stock'
      ]) || this.hasTruthyMatchingField(grid, (field) => {
        return field.indexOf('stock') != -1;
      });
    },
    hasTruthyField(grid, fields) {
      if (!grid) return false;
      return fields.some((field) => this.isTruthyStockValue(grid[field]));
    },
    hasTruthyMatchingField(grid, matcher) {
      if (!grid) return false;
      return Object.keys(grid).some((field) => {
        return matcher(field.toLowerCase()) && this.isTruthyStockValue(grid[field]);
      });
    },
    isTruthyStockValue(value) {
      if (value === false || value === null || value === undefined || value === '') return false;
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'number') return value > 0;
      if (typeof value === 'string') {
        const text = value.trim();
        if (text === '' || text.toLowerCase() === 'false') return false;
        const numberValue = Number(text);
        if (!Number.isNaN(numberValue)) return numberValue > 0;
        return true;
      }
      if (typeof value === 'object') return Object.keys(value).length > 0;
      return !!value;
    },
    // 查看库位商品
    gridStockDetail() {

      this.$api.warehouseApi
        .gridStockDetail({ grid_number: this.item.grid_number, page: this.page })
        .then((res) => {
          this.goodList = [...this.goodList, ...res.data.data]
          this.total = res.data.total
          this.page++
          this.operationDialogVisible = false;
          this.warehouseGoodsDialogVisible = true;
          console.log(res);
        });
    },
    //重置 库位商品
    resetGoods() {
      this.goodList = []
      this.total = 0
      this.page = 1

    },
    // 开启选择
    /* 开启库位操作选择，并记录当前库位所属货架 */
    chooseOperation(item, shelves = {}, shelfLayer = {}) {
      this.item = item;
      this.shelves = shelves;
      this.shelfLayer = shelfLayer;
      this.operationDialogVisible = true;
    },
    // 仅选择库位，不执行入库或移库；父组件负责后续业务提交
    selectGridNumber() {
      this.$parent.datas.grid_number = this.item.grid_number
      this.operationDialogVisible = false
      this.$parent.warehouseDialogVisible = false
      if (this.$parent.submitPacking) {
        this.$parent.submitPacking()
      }
    },
    // 选择长存仓库库位，交给父组件继续提交上架
    selectChargeGridNumber() {
      if (this.$parent.selectChargeGridNumber) {
        this.$parent.selectChargeGridNumber(this.item.grid_number, this.item, this.shelves, this.shelfLayer)
      }
      this.operationDialogVisible = false
      this.$parent.warehouseDialogVisible = false
    },
    // 将新库位完整信息交给核查页，接口成功后再关闭库位选择界面。
    selectBatchMoveGrid() {
      if (!this.$parent.submitBatchMove) return
      const request = this.$parent.submitBatchMove(this.item.id, this.item.grid_number, this.item, this.shelves, this.shelfLayer)
      if (!request || typeof request.then !== 'function') return
      request.then(() => {
        this.operationDialogVisible = false
        this.$parent.warehouseDialogVisible = false
      })
    },
    //入库
    stockMove() {
      let datas = {
        grid_number: this.item.grid_number,
        list: this.yiku_data,
      };
      this.$api.warehouseApi.stockMove(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.stockMoveSuccess();
        this.operationDialogVisible = false;
      });
    },
    //核查-上架提交
    followUpStorage() {
      let datas = {
        grid_id: this.item.id,
        data: this.up_data,
      };
      this.$api.inspectionApi.followUpStorage(datas).then((res) => {
        if (res.code == 10006) {
          this.skipSpotCheck(res.msg)
          return fasle
        }
        this.$message.success(res.msg);
        this.followUpStorageSuccess()
      });
    },
    // 核查上架成功后通知父页面，父页面可接管后续流程
    followUpStorageSuccess() {
      this.operationDialogVisible = false;
      this.$parent.warehouseDialogVisible = false;
      if (this.$parent.afterFollowUpStorage) {
        this.$parent.afterFollowUpStorage(this.item.grid_number, this.item, this.shelves, this.shelfLayer)
      } else if (this.$parent.isAllUpStorage) {
        this.$parent.isAllUpStorage()
      }
    },
    // 上架跳过检品抽查
    skipSpotCheck(msg) {
      this.$confirm(
        msg,
        this.$t("message.hint"),
        {
          confirmButtonText: '继续操作', //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            grid_id: this.item.id,
            data: this.up_data,
            reconfirm: 1
          };
          this.$api.inspectionApi.followUpStorage(datas).then((res) => {
            this.$message.success(res.msg);
            this.followUpStorageSuccess()
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //直接装箱-入普通仓库
    boxToNormalWms() {
      let datas = {
        grid_number: this.item.grid_number,
        boxIds: this.boxIds,
      };

      this.$api.porderApi.boxToNormalWms(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.warehouseDialogVisible = false;
        this.operationDialogVisible = false;
        this.$parent.boxList();
      });
    },
    //直接装箱-入收费仓库
    boxToChargeWms() {
      let datas = {
        grid_number: this.item.grid_number,
        boxIds: this.boxIds,
      };
      this.$confirm(
        this.$t(
          "商品确定转入收费仓库吗？转入收费仓库后，系统将自动根据该客户在仓库的体积进行收费！"
        ),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.porderApi.boxToChargeWms(datas).then((res) => {
            this.$message.success(res.msg);
            this.$parent.warehouseDialogVisible = false;
            this.operationDialogVisible = false;
            this.$parent.boxList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 直接装箱-选择库位后标记装箱完成
    boxToComplete() {
      let datas = {
        ids: this.boxIds,
        grid_id: this.item.id,
        grid_number: this.item.grid_number,
      };
      this.$api.inspectionApi.toComplete(datas).then((res) => {
        this.$message.success(res.msg);
        this.operationDialogVisible = false;
        this.$parent.warehouseDialogVisible = false;
        this.$parent.markPackingFinishedSuccess();
      });
    },
    //装箱取出
    outBoxSubmit() {
      this.cancelEncasementData.grid_number = this.item.grid_number;
      this.$api.porderApi
        .outBoxSubmit(this.cancelEncasementData)
        .then((res) => {
          this.$message.success(res.msg);
          this.operationDialogVisible = false;
          this.$parent.takeOutSucess();
        });
    },
    //单商品多箱取出
    outBoxBatchSubmit() {
      this.cancelEncasementData.grid_number = this.item.grid_number;
      this.$api.porderApi
        .outBoxBatchSubmit(this.cancelEncasementData)
        .then((res) => {
          this.$message.success(res.msg);
          this.operationDialogVisible = false;
          this.$parent.takeOutSucess();
        });
    },
    //多商品全部取出
    outBoxAllSubmit() {
      this.cancelEncasementData.grid_number = this.item.grid_number;
      this.$api.porderApi
        .outBoxAllSubmit(this.cancelEncasementData)
        .then((res) => {
          this.$message.success(res.msg);
          this.operationDialogVisible = false;
          this.$parent.takeOutSucess();
        });
    },
    //批量上架到长存库存
    batchUpToShelf() {
      let datas = {
        ids: this.up_data,
        grid_number: this.item.grid_number,
      };
      this.$api.inventoryTransferApi.batchUpToShelf(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.warehouseDialogVisible = false;
        this.operationDialogVisible = false;
        this.$parent.listCompleteBoxs();
      });
    },
    // 转库单取消装箱
    moveOutBox() {
      this.cancelEncasementData.target_grid_number = this.item.grid_number;
      this.$api.inventoryTransferApi.outBox(this.cancelEncasementData).then((res) => {
        this.$message.success(res.msg);
        this.operationDialogVisible = false;
        this.$parent.takeOutSucess();
      });
    },

    // 转库单取消装箱
    batchMoveBackToNormal() {
      let datas = {
        grid_number: this.item.grid_number,
        boxes: this.up_data,
      };
      this.$api.warehouseApi.batchMoveBackToNormal(datas).then((res) => {
        this.$message.success(res.msg);
        this.operationDialogVisible = false;
        this.$parent.warehouseDialogVisible = false;
        this.$parent.chargeStorageList()
      });
    },
    //打印上架唛头
    printLabel() {
      this.$parent.labelData.grid_number = this.item.grid_number;
      if (this.$route.name == 'inspectDetail') {
        this.$parent.printLabel()
      } else {
        this.$parent.jpPrintLabel()
      }
      this.operationDialogVisible = false;
      this.$parent.warehouseDialogVisible = false;
    },
  },
};
</script>
<style lang='scss' scoped>
.up-storage-order-list {
  max-height: 170px;
  margin: 0 40px 16px;
  overflow-y: auto;
}

.order-shelf-filter {
  min-height: 44px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;

  color: #fff;
  font-size: 14px;
}

.up-storage-order-info {
  min-height: 72px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  background: #56596f;
  color: #fff;
  font-size: 14px;

  p {
    margin: 3px 0;
  }

  >div {
    box-sizing: border-box;
    padding: 8px 16px;
  }

  .order-time {
    width: 200px;
  }

  .order-customer {
    width: 360px;
  }

  .customer-name {
    margin-top: 4px;
    font-size: 18px;
    font-weight: bold;
  }

  .order-number {
    width: 380px;
  }

  .order-staff {
    flex: 1;
    display: flex;
    justify-content: space-around;
    gap: 16px;
    white-space: nowrap;
  }

  .a-link {
    color: #ffef00;
  }

  .el-icon-copy-document {
    margin-left: 4px;
    color: #2c96e7;
    cursor: pointer;
  }

  .attribute-name {
    display: inline-block;
    vertical-align: middle;

    /deep/div {
      display: inline-block;
    }
  }

  .express-list-button {
    margin-left: 6px;
    padding: 4px;
  }
}

.nav {
  margin-left: 40px;
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  .item {
    width: 160px;
    height: 48px;
    line-height: 48px;
    border: 2px solid #b4272d;
    font-size: 18px;
    color: #b4272d;
    text-align: center;
    cursor: pointer;

    &:nth-child(1) {
      border-radius: 4px 0 0 4px;
      border-right: 0;
    }

    &:nth-child(2) {
      border-radius: 0 4px 4px 0;
    }
  }

  .shelf-filter {
    margin-left: 16px;
    border-radius: 4px;
  }

  .layout-actions {
    display: flex;
    flex-shrink: 0;
    margin-left: auto;
    padding-right: 40px;

    .layout-button+.layout-button {
      margin-left: 12px;
    }
  }

  .index {
    color: #fff;
    background-color: #b4272d;
  }

  .warehouse-legend {
    display: grid;
    grid-template-columns: repeat(2, max-content);
    align-items: center;
    column-gap: 18px;
    row-gap: 8px;
    margin-left: 20px;
    font-size: 14px;
    color: #333;
  }

  .legend-item {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .legend-dot {
    width: 14px;
    height: 14px;
    margin-right: 6px;
    border: 1px solid #333;
    border-radius: 50%;
    display: inline-block;
  }

  .empty {
    background-color: #fff;
  }

  .has-stock {
    background-color: #85ce61;
    border-color: #85ce61;
  }

  .customer-stock {
    background-color: #000;
    border-color: #000;
  }

  .same-goods {
    background-color: #fff189;
    border-color: #fff189;
  }
}

.content {
  margin: 0px 15px;

  .list {
    padding: 32px 40px;
    background-color: #f8f8f8;
    border-radius: 8px;
    overflow: auto;
    height: calc(100vh - 260px);

    &.with-order-info {
      height: calc(100vh - 370px);
    }

    .shelf-canvas {
      position: relative;
      min-width: 1650px;
      min-height: 100%;

      &::after {
        display: block;
        clear: both;
        content: '';
      }
    }

    // display: flex;
    // flex-wrap: wrap;
    .shelves {
      width: 506px;
      background: #fff;
      border: 1px solid #333333;
      border-radius: 4px;
      float: left;
      display: flex;
      margin-right: 64px;
      margin-bottom: 24px;
      will-change: transform;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .shelves-main {

        // display: flex;
        .header {
          border-bottom: 1px solid #333;
          display: flex;
          width: 100%;

          .serialNumber {
            flex: 1 1 auto;
            width: auto;
            min-width: 0;

            p {
              width: 100%;
              min-width: 0;
              padding: 0 5px;
              box-sizing: border-box;
              line-height: 1.2;
              overflow-wrap: anywhere;
              word-break: break-word;
            }
          }

          .key-range {
            flex: 0 0 72px;
            width: 72px;
          }

          // 固定右侧使用范围宽度，剩余空间全部由货架编号自适应占用。
          .range {
            flex: 0 0 108px;
            width: 108px;
          }

          div {
            border-right: 1px solid #333;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 44px;

            &:nth-last-child(1) {
              border: 0;
            }
          }
        }

        .row {
          border-bottom: 1px solid #333;
          display: flex;
          width: 100%;

          &:nth-last-child(1) {
            border: 0;
          }

          div {
            border-right: 1px solid #333;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 15px 0;

            &:nth-last-child(1) {
              border: 0;
            }
          }

          .key {
            margin-right: 1px solid #333;
            width: 64px;
          }

          .each-layer {
            width: 360px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            padding: 0;

            // height: 72px;
            div {
              border: 0;
            }

            .item {
              padding: 0;
              margin: 5px 10px 5px 0;
              width: 22px;
              height: 22px;
              border: 1px solid #333;
              border-radius: 50%;
              cursor: pointer;
            }



            .grid-has-stock {
              background-color: #85ce61;
              border: 1px solid #85ce61;
              color: #fff;
            }

            .grid-customer-stock {
              background-color: #000;
              border: 1px solid #000;
              color: #fff;
            }

            .grid-same-goods {
              background-color: #fff189;
              border: 1px solid #fff189;
              color: #333;
            }
          }
        }
      }

      .shelves-name {
        width: 80px;
        border-left: 1px solid #333;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 5px;

        &.drag-handle {
          position: relative;
        }

        .drag-icon {
          position: absolute;
          top: 6px;
          right: 6px;
          color: #b4272d;
          font-size: 18px;
        }
      }

      &.layout-editing .drag-handle {
        cursor: move;
        cursor: grab;
        user-select: none;
        touch-action: none;
        background-color: #fff7f7;
      }

      &.layout-editing .drag-handle:active {
        cursor: grabbing;
      }
    }

    .free-layout .shelves {
      position: absolute;
      top: 0;
      left: 0;
      float: none;
      margin: 0;
      box-sizing: border-box;

      .shelves-main {
        flex: 1;
        min-width: 0;

        .row .each-layer {
          flex: 1;
          width: auto;
        }
      }

      .shelves-name {
        box-sizing: border-box;
        flex: 0 0 80px;
      }

      &.layout-editing {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
        touch-action: none;

        &::after {
          position: absolute;
          top: 0;
          right: -4px;
          width: 8px;
          height: 100%;
          border-right: 3px solid #b4272d;
          box-sizing: border-box;
          content: '';
          cursor: ew-resize;
        }
      }
    }
  }
}

.table {
  max-height: 700px;
  overflow-y: auto;

  .flex05 {
    flex: 0.5;
  }

  .template {
    width: 100%;
    text-align: left;
  }

  .wu {
    text-align: center;
    margin: 20px;
  }
}

/deep/.el-dialog {
  margin: 0 !important;
  //   position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/deep/.el-message-box__wrapper {
  z-index: 9999 !important;
}

.btn {
  text-align: center;
}
</style>
